import React, { useEffect, useRef } from 'react';
import { Ad } from '../types';
import { adApi } from '../utils/api';

interface AdDisplayProps {
  ads: Ad[];
}

const AdDisplay: React.FC<AdDisplayProps> = ({ ads }) => {
  const containerRefs = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    ads.forEach((ad, index) => {
      if (ad.ad_type === 'code' && ad.content) {
        const container = containerRefs.current[index];
        if (container) {
          try {
            container.innerHTML = ad.content;
            
            const scripts = container.querySelectorAll('script');
            scripts.forEach(oldScript => {
              const newScript = document.createElement('script');
              Array.from(oldScript.attributes).forEach(attr => {
                newScript.setAttribute(attr.name, attr.value);
              });
              newScript.textContent = oldScript.textContent;
              oldScript.parentNode?.replaceChild(newScript, oldScript);
            });
          } catch (error) {
            console.error('Failed to render ad code:', error);
          }
        }
      }
    });
  }, [ads]);

  const handleAdClick = async (ad: Ad) => {
    if (ad.ad_type === 'image') {
      try {
        await adApi.clickAd(ad.id);
      } catch (error) {
        console.error('Failed to track ad click:', error);
      }
    }
  };

  return (
    <div className="space-y-4">
      {ads.map((ad, index) => (
        <div key={ad.id} className="ad-container">
          {ad.ad_type === 'code' ? (
            <div
              ref={el => { containerRefs.current[index] = el as HTMLDivElement; }}
              className="code-ad"
            />
          ) : (
            <a
              href={ad.link_url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => handleAdClick(ad)}
              className="block"
            >
              {ad.image_url ? (
                <img
                  src={ad.image_url}
                  alt={ad.title}
                  className="w-full max-w-full"
                />
              ) : (
                <div className="bg-gray-100 p-4 text-center">
                  <h3 className="font-medium text-gray-900">{ad.title}</h3>
                  <p className="text-sm text-gray-600 mt-1">{ad.content}</p>
                </div>
              )}
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

export default AdDisplay;